import { ILegalClusterConfigType } from '../entities/IConfiguration';
import { IPlatformConfiguration } from '../entities/IPlatformConfiguration';
import { IPremiumFeatures } from '../entities/IPremiumFeatures';
import * as actionTypes from './actionTypes/configTypes';
import { action } from '../tools/reduxTools';

export const getApplicationConfig = () => action<Promise<ILegalClusterConfigType>>((dispatch) => {
        const mapAndDispatch = (response: Response) => response.json() as Promise<ILegalClusterConfigType>;

    return fetch(`config.json?_=${Date.now()}`, { cache: 'no-store' })
        .then(response => {
            if (response.ok) {
                return mapAndDispatch(response);
            }

            return fetch('api/Config/GetLegalClusterConfig').then(mapAndDispatch);
        })
        .catch(() => fetch('api/Config/GetLegalClusterConfig').then(mapAndDispatch))
        .then(appConfig => {
            dispatch({
                type: actionTypes.GET_APPLICATION_CONFIG,
                appConfig
            } as IGetApplicationConfig);

            return appConfig;
        });
});

export interface IGetApplicationConfig {
    type: string,
    appConfig: ILegalClusterConfigType
}

export interface IGetPremiumConfiguration {
    type: string;
    premiumFeatures: IPremiumFeatures;
}

export interface IGetPlatformConfigurationSuccess {
    type: string;
    platformConfiguration: IPlatformConfiguration;
}

export interface IUpdatePlatformConfiguration extends IGetPlatformConfigurationSuccess {
    previousPlatformConfiguration?: IPlatformConfiguration;
}
